"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import BranchSettingsService, { BranchSettings, SKIP_PRODUCTION_SCOPE } from "../services/branch-settings-service";
import SkipProductionScope from "../components/skip-production-scope";
import BranchService, { Branch } from "../../branch/services/branch-service";
import { isSuccess } from "../../../models/response/base-response";
import { showToast } from "../../../components/custom/custom-toast";

/** Extract array from API response: array | { list: [] } | { data: [] } */
function extractList(raw: any): any[] {
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === "object") {
    const arr = raw.list ?? raw.data;
    if (Array.isArray(arr)) return arr;
  }
  return [];
}

interface FeatureToggle {
  key: keyof Pick<BranchSettings,
    "enable_equipment" | "enable_qr_scan" | "enable_extended_workflow" |
    "enable_item_classification" | "enable_sub_orders" | "enable_skip_production"
  >;
  label: string;
  description: string;
  icon: React.ReactNode;
}

const FEATURE_TOGGLES: FeatureToggle[] = [
  // {
  //   key: "enable_equipment",
  //   label: "Quản lý thiết bị",
  //   description: "Bật/tắt tính năng gắn thiết bị (túi, máy giặt, máy sấy, bàn ủi, bàn gấp, sọt) vào đơn hàng",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
  //     </svg>
  //   ),
  // },
  // {
  //   key: "enable_qr_scan",
  //   label: "Quét mã QR/Barcode",
  //   description: "Cho phép nhân viên quét barcode trên thiết bị để xem đơn hàng",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z" />
  //     </svg>
  //   ),
  // },
  // {
  //   key: "enable_extended_workflow",
  //   label: "Quy trình mở rộng",
  //   description: "Bật quy trình xử lý đơn hàng nâng cao với nhiều bước hơn",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
  //     </svg>
  //   ),
  // },
  // {
  //   key: "enable_item_classification",
  //   label: "Phân loại đồ giặt",
  //   description: "Cho phép phân loại chi tiết đồ giặt theo loại vải, màu sắc...",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6z" />
  //     </svg>
  //   ),
  // },
  // {
  //   key: "enable_sub_orders",
  //   label: "Chia đơn con",
  //   description: "Cho phép chia đơn hàng lớn thành nhiều đơn con để xử lý riêng",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
  //     </svg>
  //   ),
  // },
  {
    key: "enable_skip_production",
    label: "Bỏ qua quét sọt/máy giặt",
    description: "Ở bước kiểm tra, nhân viên bấm \"Hoàn thành sản xuất\" (nhập số kg) để sang bước Đang sản xuất mà không cần quét sọt/máy giặt. Bước đóng túi vẫn giữ như thường. Có thể giới hạn chỉ cho một số khách.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
      </svg>
    ),
  },
];

const BranchSettingsIndexPage: React.FC = () => {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [selectedBranchId, setSelectedBranchId] = useState<number | undefined>();
  const [settings, setSettings] = useState<BranchSettings | null>(null);
  const [saving, setSaving] = useState(false);

  // CHỈ chi nhánh user có quyền (my-branches): is_all_branch/ADMIN → tất cả; còn lại → theo user_branch_maps.
  const { fetch: listBranches } = BranchService.myBranches();
  const { fetch: getSettings, loading: loadingSettings } = BranchSettingsService.get();
  const { fetch: updateSettings } = BranchSettingsService.update();

  const branchListRef = useRef(listBranches);
  useEffect(() => { branchListRef.current = listBranches; }, [listBranches]);

  const getSettingsRef = useRef(getSettings);
  useEffect(() => { getSettingsRef.current = getSettings; }, [getSettings]);

  const updateSettingsRef = useRef(updateSettings);
  useEffect(() => { updateSettingsRef.current = updateSettings; }, [updateSettings]);

  // Load branches
  useEffect(() => {
    (async () => {
      const res = await branchListRef.current();
      if (res && isSuccess(res)) {
        const branchList = extractList(res.data);
        setBranches(branchList);
        if (branchList.length > 0) {
          setSelectedBranchId(branchList[0].id);
        }
      }
    })();
  }, []);

  // Load settings when branch changes
  const loadSettings = useCallback(async () => {
    if (!selectedBranchId) return;
    const res = await getSettingsRef.current(selectedBranchId);
    if (res && isSuccess(res)) {
      setSettings(res.data as any);
    }
  }, [selectedBranchId]);

  useEffect(() => { void loadSettings(); }, [loadSettings]);

  const handleToggle = async (key: FeatureToggle["key"]) => {
    if (!settings) return;
    await updateField(key, settings[key] === 1 ? 0 : 1);
  };

  const updateField = async (key: FeatureToggle["key"] | "skip_production_scope", newValue: number) => {
    if (!settings || !selectedBranchId) return;
    setSaving(true);
    const res = await updateSettingsRef.current(selectedBranchId, { [key]: newValue });
    setSaving(false);

    if (res && isSuccess(res)) {
      setSettings((prev) => prev ? { ...prev, [key]: newValue } : prev);
      showToast({ message: "Cập nhật thành công", type: "success" });
    } else {
      showToast({ message: res?.message || "Cập nhật thất bại", type: "error" });
    }
  };

  return (
    <div className="space-y-6 w-full">
      {/* ── HEADER ── */}
      <div>
        <h1 className="text-2xl font-extrabold text-green-600 tracking-tight">
          Cài đặt chi nhánh
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Bật/tắt các tính năng theo từng chi nhánh
        </p>
      </div>

      {/* ── MAIN CONTENT CARD ── */}
      <div className="rounded-2xl bg-white shadow-sm border border-gray-100 overflow-hidden">

        {/* ── BRANCH SELECTOR ── */}
        <div className="px-6 py-5 border-b border-gray-100 flex items-center gap-4">
          <label className="text-sm font-semibold text-gray-600 whitespace-nowrap">Chi nhánh:</label>
          <select
            value={selectedBranchId ?? ""}
            onChange={(e) => setSelectedBranchId(Number(e.target.value))}
            className="rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm focus:border-green-500 focus:outline-none focus:ring-4 focus:ring-green-500/10 transition-all cursor-pointer w-80"
          >
            {branches.map((b) => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
        </div>

        {/* ── FEATURE TOGGLES ── */}
        <div className="p-6">
          {loadingSettings ? (
            <div className="flex items-center justify-center py-12 text-gray-400">
              <svg className="animate-spin h-6 w-6 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              <span className="text-sm font-medium">Đang tải cài đặt...</span>
            </div>
          ) : settings ? (
            <div className="space-y-3">
              {FEATURE_TOGGLES.map((feature) => {
                const isEnabled = settings[feature.key] === 1;
                return (
                  <div
                    key={feature.key}
                    className={`rounded-xl border p-4 transition-all ${
                      isEnabled
                        ? "border-green-200 bg-green-50/50"
                        : "border-gray-100 bg-gray-50/30 hover:bg-gray-50"
                    }`}
                  >
                  <div className="flex items-center justify-between">
                    <div className="flex items-start gap-3 flex-1">
                      <div className={`mt-0.5 rounded-lg p-2 ${
                        isEnabled ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"
                      }`}>
                        {feature.icon}
                      </div>
                      <div className="flex-1">
                        <div className={`font-semibold text-sm ${
                          isEnabled ? "text-green-800" : "text-gray-700"
                        }`}>
                          {feature.label}
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5">{feature.description}</div>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleToggle(feature.key)}
                      disabled={saving}
                      className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors shrink-0 ml-4 ${
                        isEnabled ? "bg-green-500" : "bg-gray-300"
                      } ${saving ? "opacity-50 cursor-wait" : "cursor-pointer"}`}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition-transform ${
                          isEnabled ? "translate-x-6" : "translate-x-1"
                        }`}
                      />
                    </button>
                  </div>
                  {feature.key === "enable_skip_production" && isEnabled && selectedBranchId && (
                    <SkipProductionScope
                      branchId={selectedBranchId}
                      scope={Number(settings.skip_production_scope) || SKIP_PRODUCTION_SCOPE.ALL}
                      disabled={saving}
                      onScopeChange={(v) => updateField("skip_production_scope", v)}
                    />
                  )}
                  </div>
                );
              })}
              {/* Timeout auto-reassign */}
              {/* <div className="mt-6 pt-6 border-t border-gray-200">
                <h3 className="text-sm font-semibold text-gray-700 mb-3">Cấu hình thời gian</h3>
                <div className="flex items-center gap-3">
                  <label className="text-sm text-gray-600">Timeout tự động đẩy đơn (phút):</label>
                  <input
                    type="number"
                    min={1}
                    max={120}
                    value={settings?.pickup_accept_timeout_minutes ?? 15}
                    onChange={async (e) => {
                      const val = Math.max(1, Number(e.target.value) || 15);
                      if (!selectedBranchId) return;
                      try {
                        await updateSettings(selectedBranchId, { pickup_accept_timeout_minutes: val });
                        setSettings(prev => prev ? { ...prev, pickup_accept_timeout_minutes: val } : prev);
                      } catch {}
                    }}
                    className="border border-gray-300 rounded px-2 py-1 text-sm w-20"
                  />
                  <span className="text-xs text-gray-400">NV không xác nhận trong thời gian này → tự động gán NV khác</span>
                </div>
              </div> */}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-400 text-sm">
              Chọn chi nhánh để xem cài đặt
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BranchSettingsIndexPage;
